import { Index } from './components';

function App() {
  return (
    <Index />
  );
}

export default App;
